import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selectIsFreeAccount, selectNumberOfRemainingUsers } from '@features/settings/store/payments.duck';
import { Center, Row } from '@shared/ui/atoms/StructuralLayout';
import { HeadlineLarge } from '@shared/ui/atoms/fonts/Headline';
import { BodyLarge } from '@shared/ui/atoms/fonts/Body';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { SuggestionMessage } from '@shared/ui/molecules/SuggestionMessage';
import { setAddTeamMemberView } from "../ducks/add-users.duck";
import { AddTeamMemberView } from "../ducks/AddUsers.model";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { useTranslation } from "react-i18next";
import Icon, { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { selectIsInTeams } from "@shared/store/auth.duck";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function AddUserSuccess(props: Props) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const remainingUsers = useSelector(selectNumberOfRemainingUsers);
  const isFreeAccount = useSelector(selectIsFreeAccount);
  const isInTeams = useSelector(selectIsInTeams);

  return (
    <>
      <Row className="addMember__header">
        <Center>
          <img style={{width: 180}} className="addMember__image" src="/assets/images/onboarding-invite-sent-image.svg" alt="" aria-hidden={true} />
        </Center>
      </Row>
      <Icon icon={IconTypes.Tick}
            style={{marginBottom: 16}}
            circle={true}
            color={'blue'}
            size={'large'} />
      <HeadlineLarge style={{marginBottom: 16}}>{t('team.team-member-invited')}</HeadlineLarge>

      <BodyLarge style={{marginBottom: 32}}>{t('payments.users-available-message', {remainingUsers: remainingUsers})}</BodyLarge>

      <PrimaryButton dataTest="addAnotherButton"
                     size={ButtonSize.Large}
                     style={{marginBottom: 24}}
                     fullWidth={true} text="button.add-another-team-member"
                     click={() => dispatch(setAddTeamMemberView(AddTeamMemberView.AddUser))}/>

      <OutlineButton dataTest="doneButton"
                     size={ButtonSize.Large}
                     fullWidth={true}
                     text="button.done-for-now"
                     {...(props.onDone ? {click: props.onDone} : {link: "/whereabouts/team"})}/>

      {isFreeAccount && !isInTeams && <SuggestionMessage
        style={{padding: 24, marginTop: 32}}
        title="did-you-know"
        linkMessage="payments.upgrade-account-in-settings"
        content="payments.with-as-many-users"
        link="/manage/payments"/>}
    </>
  )
}

interface Props {
  // When set (e.g. inside a dialog), "done" hands control back to the host
  // instead of navigating away.
  onDone?: () => void;
}
